/**
 * FormSection — Section wrapper with an uppercase title + trailing divider line.
 * Used to group related fields ("Basic Information", "Job Details", etc.)
 *
 * Usage:
 *   <FormSection title="Basic Information">
 *     ...fields...
 *   </FormSection>
 */
import styles from "./jobForm.module.css";

export default function FormSection({ title, children }) {
  return (
    <div className={styles.section}>
      {title && <div className={styles.title}>{title}</div>}
      {children}
    </div>
  );
}
